import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IApkAssignmentContext, ApkAssignmentContext } from '../../../../../apkAssignmentState/apkAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './ApkCrumb.module.scss';

const ApkCrumb: React.FC = () => {
	const { deleteApkFromRestaurant, apk } = useContext<IApkAssignmentContext>(ApkAssignmentContext);

	return (
		<div className={style.container} data-test="ApkCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="tabletAppLabel"
					size="s"
					weight="bold"
				/>
				{apk.map((restaurant, i) => {
					const isAnyApkSelected = !!restaurant.tabletApps.length;

					return (
						<div key={restaurant.restaurantId} data-test={`item-${i}`}>
							{isAnyApkSelected && (
								<Text
									className={style.sectionName}
									translationKey={restaurant.restaurantAddress}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{restaurant.tabletApps.map((tabletApp) => {
									return (
										<SelectedItemForBreadcrumbs
											key={tabletApp.tabletAppId}
											label={tabletApp.versionName || ''}
											onDelete={() =>
												deleteApkFromRestaurant(restaurant.restaurantId, tabletApp.tabletAppId)
											}
										/>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ApkCrumb;
